import { render, staticRenderFns } from "./FilterTotalRoomsBlock.vue?vue&type=template&id=659737f3&"
import script from "./FilterTotalRoomsBlock.vue?vue&type=script&lang=js&"
export * from "./FilterTotalRoomsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports